import { Box, Button, Paper, Stack, Typography } from '@mui/material'
import AutoAwesome from '@mui/icons-material/AutoAwesome'
import ArrowBack from '@mui/icons-material/ArrowBack'
import { useLocation, useNavigate } from 'react-router-dom'
import { t } from '../i18n'

/**
 * s59 (decisao T2 de Marcelo: ele escreve a palavra final -- texto APROVADO em 17/10/2026) -- "Como a IA trata seus
 * dados". Pagina so de leitura, rota fixa /ia-e-seus-dados (ADR-0024 D10.1: nada de dado na URL), aberta pelo link do
 * painel de IA. O texto mora em i18n (aiData) com a data da revisao; muda a politica do provedor, muda o texto.
 * Transparencia, nao base legal: a base da transferencia internacional (LGPD art. 33) vive no contrato/politica.
 * Fatia 2c: tela so com protecao (P8a/P8b), sem rodape (17:28: nada de contrato/Politica na operacao); botao "Voltar" (A5-s59): volta para a tela
 * de onde veio; aberta direto pelo endereco (location.key 'default' = primeira tela do app), vai para Cargos.
 */
export function AiDataPage() {
  const navigate = useNavigate()
  const location = useLocation()
  const voltar = () => (location.key !== 'default' ? navigate(-1) : navigate('/cargos'))
  return (
    <Stack spacing={2} sx={{ maxWidth: 760 }}>
      <Box>
        <Button size="small" startIcon={<ArrowBack fontSize="small" />} onClick={voltar}>
          {t.aiData.back}
        </Button>
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <AutoAwesome color="primary" />
        <Typography variant="h1" sx={{ fontSize: '1.5rem' }}>
          {t.aiData.title}
        </Typography>
      </Box>
      {t.aiData.sections.map((s) => (
        <Paper key={s.title} variant="outlined" component="section" sx={{ p: 2 }}>
          <Typography variant="h2" sx={{ fontSize: '1.0625rem', mb: 0.5 }}>
            {s.title}
          </Typography>
          <Typography variant="body2">{s.body}</Typography>
        </Paper>
      ))}
      <Typography variant="caption" color="text.secondary">
        {t.aiData.reviewed}
      </Typography>
    </Stack>
  )
}
